/**
 * @desc 查询周计划tab页标题名称
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekTabResponse>>> {
  return defHttp.post({
    url: '/wap/plan/week/queryPlanTabs',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekTabResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/week/queryPlanTabs',
    data,
  });
}
